query PlatformsSearchAutocomplete($search: String) {
  platforms(rowsPerPage: 50, filter: { search: $search }) {
    nodes {
      id
      title
    }
  }
}
